import type { IframeHTMLAttributes } from 'react'
import ReactMarkdown, { Options } from 'react-markdown'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import gfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import rehypeHighlight from 'rehype-highlight'
import {
  GAEvent,
  referrerPolicyForMarkdownYoutubeIframe,
  sendCustomGAEvent,
} from 'shared-utilities'
import LinkComponent from '../LinkComponent/LinkComponent'

import 'katex/dist/katex.min.css'
import 'highlight.js/styles/github.css'

const MarkdownText = ({
  text,
  className = '',
  gaEventCategory,
  gaEventLabel,
  gaEventValue,
}: {
  text: string
  className?: string
  gaEventCategory?: string
  gaEventLabel?: string
  gaEventValue?: string
}) => {
  return (
    <ReactMarkdown
      data-testid="markdown-text"
      className={className}
      linkTarget="_blank"
      remarkPlugins={[remarkMath, gfm]}
      rehypePlugins={
        [rehypeKatex, rehypeHighlight, rehypeRaw] as Options['rehypePlugins']
      }
      components={{
        h1: 'h2',
        p: ({ children }) => <p className="leading-normal">{children}</p>,
        table: ({ ...props }) => (
          <div className="table-wrapper">
            <table {...props} />
          </div>
        ),
        a: ({ ...props }) => (
          <LinkComponent
            {...props}
            // eslint-disable-next-line react/prop-types
            href={String(props.href)}
            onClick={
              gaEventCategory
                ? () => {
                    sendCustomGAEvent('click', {
                      event_category: gaEventCategory,
                      // eslint-disable-next-line react/prop-types
                      event_label: gaEventLabel || props.children[0],
                      // eslint-disable-next-line react/prop-types
                      value: gaEventValue || props.href,
                    } as GAEvent)
                  }
                : undefined
            }
          />
        ),
        iframe: ({
          src,
          referrerPolicy,
          ...props
        }: IframeHTMLAttributes<HTMLIFrameElement>) => (
          <iframe
            {...props}
            src={src}
            referrerPolicy={referrerPolicyForMarkdownYoutubeIframe(
              typeof src === 'string' ? src : undefined,
              referrerPolicy
            )}
          />
        ),
      }}
    >
      {text}
    </ReactMarkdown>
  )
}

export default MarkdownText
